
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'Clinics',

  async fetch() {
    if (!this.clinics?.length > 0) {
      const clinics = await this.$wp.clinics();
      this.setClinics(clinics.data);
    }
    if (!this.staff?.length > 0) {
      const staff = await this.$wp.staff();
      this.setStaff(staff.data);
    }
  },

  async asyncData({ $wp }) {
    const slug = 'clinic';
    let page;
    const { data } = await $wp.pages({ slug });
    if (data && data.length) {
      page = { ...data[0] };
    }
    return { page };
  },

  computed: {
    ...mapState({
      info: (state) => state.options.field_clinics_start,
      clinics: (state) => state.clinics,
      staff: (state) => state.staff,
    }),

    blocks() {
      return this.page && this.page.acf ? this.page.acf.blocks : [];
    },
  },

  methods: {
    ...mapMutations(['setClinics', 'setStaff']),

    toClinic(clinic) {
      this.$router.push(
        this.localePath({
          name: 'clinic-slug',
          params: { slug: clinic.slug },
        })
      );
    },
  },

  head() {
    return this.$seo.page('clinics', this.$route.path);
  },
};
